import React, { useEffect, useState } from "react";
import { FiPlus } from "react-icons/fi";
import { GoPencil } from "react-icons/go";
import { BsTrash3 } from "react-icons/bs";
import AddVehicle from "./AddVehicle";
import AdminLayout from "../../layout/AdminLayout";
import { getCurrentUser } from "../../../api/user.api";
import { confirmVehicleDelete, success } from "../../../utils/notifications";
import { deleteVehicle, getAllVehicles } from "../../../api/vehicle.api";
import { baseURL } from "../../../api/api";
import { RotatingLines } from "react-loader-spinner";
import placeholderVehicle from "../../../assets/images/Register Owner Image.png";

const initialData = {
  image: "",
  brand: "",
  model: "",
  type: "",
  service: "",
  ownerId: "",
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
  registrationNumber: "",
  accessCode: "",
  location: "",
};

function Vehicles() {
  const [addVehicleOpen, setAddVehicleOpen] = useState(false);
  const [vehiclesData, setVehiclesData] = useState([]);
  const [editVehiclesData, setEditVehiclesData] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchVehicles = () => {
    setLoading(true);
    getCurrentUser()
      .then((res) => {
        getAllVehicles()
          .then((res) => {
            setVehiclesData(res?.data?.vehicles);
            setLoading(false);
          })
          .catch((error) => {
            setLoading(false);
            console.error("Error fetching data:", error);
          });
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching data:", error);
      });
  };

  useEffect(() => {
    fetchVehicles();
  }, []);

  const handleDelete = (id) => {
    confirmVehicleDelete().then(async (result) => {
      if (result.isConfirmed) {
        await deleteVehicle(id);
        setVehiclesData(vehiclesData.filter((vehicle) => vehicle._id !== id));
        await success("Success!", "Mobile Location deleted successfully!");
      }
    });
  };

  return (
    <>
      <AddVehicle
        open={addVehicleOpen}
        setOpen={setAddVehicleOpen}
        fetchVehicles={fetchVehicles}
        initialData={initialData}
        vehiclesData={editVehiclesData}
      />
      <AdminLayout title="Mobile Locations Management">
        <div className="px-1 sm:px-3 lg:px-8">
          <div className="mb-5 flex items-center justify-end sticky top-16 bg-slate-50 py-3 z-10 px-2">
            <button
              onClick={() => {
                setAddVehicleOpen(true);
                setEditVehiclesData(initialData);
              }}
              className="flex items-center justify-center rounded-md bg-yellowColor px-3 py-2.5 text-base font-semibold text-gray-700 shadow-sm hover:bg-opacity-90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-yellowColor"
            >
              <FiPlus className="text-lg text-gray-700" />
              Add Mobile Location
            </button>
          </div>

          {loading ? (
            <div className="flex justify-center items-center h-64">
              <RotatingLines
                strokeColor="black"
                strokeWidth="5"
                animationDuration="0.75"
                width="96"
                visible={true}
              />
            </div>
          ) : (
            <div className="mt-5 flow-root">
              {vehiclesData.length === 0 ? (
                <div className="text-center font-bold text-gray-600 text-xl my-4">
                  No mobile Locations added.
                </div>
              ) : (
                <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                  <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                    {/* Mobile view (only shows on small screens) */}
                    <div className="md:hidden space-y-4">
                      {vehiclesData.map((vehicle, index) => (
                        <div
                          key={index}
                          className="bg-white rounded-lg shadow p-4 ms-2 me-2"
                        >
                          <div className="flex flex-col">
                            <div className="mb-4">
                              {vehicle?.image ? (
                                <img
                                  className="object-cover h-40 w-full rounded-md"
                                  src={`${baseURL}/s3/images/${vehicle.image}`}
                                  alt="vehicle"
                                  onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = placeholderVehicle;
                                  }}
                                />
                              ) : (
                                <img
                                  className="object-cover h-40 w-full rounded-md"
                                  src={placeholderVehicle}
                                  alt="vehicle placeholder"
                                />
                              )}
                            </div>

                            <div className="grid grid-cols-2 gap-3">
                              <div>
                                <p className="text-gray-500 text-sm">
                                  Registration
                                </p>
                                <p className="font-medium">
                                  {vehicle?.registrationNumber || "-"}
                                </p>
                              </div>

                              <div>
                                <p className="text-gray-500 text-sm">
                                  Location
                                </p>
                                <p className="font-medium">
                                  {vehicle?.location || "-"}
                                </p>
                              </div>

                              <div>
                                <p className="text-gray-500 text-sm">Brand</p>
                                <p className="font-medium">
                                  {vehicle?.brand || "-"}
                                </p>
                              </div>

                              <div>
                                <p className="text-gray-500 text-sm">Model</p>
                                <p className="font-medium">
                                  {vehicle?.model || "-"}
                                </p>
                              </div>

                              <div>
                                <p className="text-gray-500 text-sm">Type</p>
                                <p className="font-medium">
                                  {vehicle?.type || "-"}
                                </p>
                              </div>

                              <div>
                                <p className="text-gray-500 text-sm">Status</p>
                                <p
                                  className={`font-medium ${
                                    vehicle?.status === "Pending Approval"
                                      ? "text-red-500"
                                      : "text-green-500"
                                  }`}
                                >
                                  {vehicle?.status || "-"}
                                </p>
                              </div>
                            </div>

                            <div className="mt-4 flex justify-end space-x-2">
                              <button
                                onClick={() => {
                                  setAddVehicleOpen(true);
                                  setEditVehiclesData(vehicle);
                                }}
                                className="h-10 w-10 flex items-center justify-center bg-green-100 text-green-700 rounded-md"
                              >
                                <GoPencil />
                              </button>
                              <button
                                onClick={() => handleDelete(vehicle._id)}
                                className="h-10 w-10 flex items-center justify-center bg-red-100 text-red-700 rounded-md"
                              >
                                <BsTrash3 />
                              </button>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>

                    {/* Desktop/tablet view (hidden on mobile) */}
                    <table className="hidden md:table bg-white rounded-lg min-w-full divide-y divide-gray-300 ">
                      <tbody className="divide-y divide-gray-200">
                        {vehiclesData.map((vehicle, index) => (
                          <tr key={index}>
                            <td className="pr-3 py-5 text-sm">
                              <div className="bg-gray-50 rounded-md h-48 w-full">
                                <div className="flex items-center justify-start">
                                  <div className="shrink-0">
                                    {vehicle?.image ? (
                                      <img
                                        className="object-cover h-48 w-80 rounded-md"
                                        src={`${baseURL}/s3/images/${vehicle.image}`}
                                        alt="vehicle img"
                                        onError={(e) => {
                                          e.target.onerror = null;
                                          e.target.src = placeholderVehicle;
                                        }}
                                      />
                                    ) : (
                                      <img
                                        className="object-cover h-48 w-80 rounded-md"
                                        src={placeholderVehicle}
                                        alt="vehicle placeholder"
                                      />
                                    )}
                                  </div>
                                  <div className="ml-5 w-96">
                                    <div className="my-1 grid grid-cols-12">
                                      <div className="col-span-6">
                                        <h1 className="text-gray-600 font-semibold text-base">
                                          Registration Number
                                        </h1>
                                      </div>
                                      <div className="col-span-6">
                                        <h1 className="text-gray-400 font-semibold text-base">
                                          {vehicle?.registrationNumber}
                                        </h1>
                                      </div>
                                    </div>
                                    <div className="my-1 grid grid-cols-12">
                                      <div className="col-span-6">
                                        <h1 className="text-gray-600 font-semibold text-base">
                                          Location
                                        </h1>
                                      </div>
                                      <div className="col-span-6">
                                        <h1 className="text-black font-semibold text-base">
                                          {vehicle?.location}
                                        </h1>
                                      </div>
                                    </div>
                                    <div className="my-1 grid grid-cols-12">
                                      <div className="col-span-6">
                                        <h1 className="text-gray-600 font-semibold text-base">
                                          Brand
                                        </h1>
                                      </div>
                                      <div className="col-span-6">
                                        <h1
                                          className="text-gray-400 font-semibold text-base truncate"
                                          title={vehicle?.brand} // Show full text on hover
                                        >
                                          {vehicle?.brand?.length > 15
                                            ? `${vehicle.brand.slice(0, 15)}...`
                                            : vehicle?.brand}
                                        </h1>
                                      </div>
                                    </div>
                                    <div className="my-1 grid grid-cols-12">
                                      <div className="col-span-6">
                                        <h1 className="text-gray-600 font-semibold text-base">
                                          Model
                                        </h1>
                                      </div>
                                      <div className="col-span-6">
                                        <h1
                                          className="text-gray-400 font-semibold text-base truncate"
                                          title={vehicle.model} // Show full text on hover
                                        >
                                          {vehicle?.model?.length > 20
                                            ? `${vehicle.model.slice(0, 20)}...`
                                            : vehicle?.model}
                                        </h1>
                                      </div>
                                    </div>
                                    <div className="my-1 grid grid-cols-12">
                                      <div className="col-span-6">
                                        <h1 className="text-gray-600 font-semibold text-base">
                                          Type
                                        </h1>
                                      </div>
                                      <div className="col-span-6">
                                        <h1 className="text-gray-400 font-semibold text-base">
                                          {vehicle.type}
                                        </h1>
                                      </div>
                                    </div>
                                    <div className="my-1 grid grid-cols-12">
                                      <div className="col-span-6">
                                        <h1 className="text-gray-600 font-semibold text-base">
                                          Status
                                        </h1>
                                      </div>
                                      <div className="col-span-6">
                                        <h1
                                          className={`font-semibold text-base ${
                                            vehicle.status ===
                                            "Pending Approval"
                                              ? "text-red-500"
                                              : "text-green-500"
                                          }`}
                                        >
                                          {vehicle.status}
                                        </h1>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </td>
                            <td className="relative whitespace-nowrap py-5 pr-4 text-right text-sm font-medium sm:pr-0">
                              <div className="pr-5 pl-1 flex items-center">
                                <button
                                  onClick={() => {
                                    setAddVehicleOpen(true);
                                    setEditVehiclesData(vehicle);
                                  }}
                                  className="text-xl h-10 w-10 flex items-center justify-center bg-green-100 text-green-700 py-0.5 px-2 rounded-md"
                                >
                                  <GoPencil />
                                </button>
                                <button
                                  onClick={() => handleDelete(vehicle._id)}
                                  className="ml-3 text-xl h-10 w-10 flex items-center justify-center bg-red-100 text-red-700 py-0.5 px-2 rounded-md"
                                >
                                  <BsTrash3 />
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </AdminLayout>
    </>
  );
}

export default Vehicles;
